<template>
  <div v-if="tableActions && tableActions.length" class="shared-actions">
    <el-dropdown trigger="click" @command="(key) => handleAction(key, data)">
      <el-button
        circle
        size="small"
        icon="el-icon-more"
      />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="action in tableActions"
          :key="action.key"
          :command="action.key"
        >
          <i :class="action.icon" :style="getIconStyle(action.type)" />
          <span>{{ action.label }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TYPE from '@/data/type'

import { deletePlace, enablePlace } from '@/services/place'
import { deleteComment, updateComment } from '@/services/comment'

import { getToShowRouter } from '@/utils/filters'
import { checkIamAction, ACTION_TO_IAM_MAP, getResourceInfo } from '@/utils/permission'

export default {
  name: 'SharedActions',
  components: {
  },
  props: {
    type: String,
    data: Object,
    actions: Array,
    routerData: Object,
    tableData: Array,
    page: Number
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['language', 'iamActions']),
    tableActions() {
      let actions = this.actions || []
      if (this.$route.name.includes('Info')) {
        actions = actions.filter((a) => a !== 'edit')
      }
      if (this.$route.name.includes('Detail')) {
        actions = actions.filter((a) => a !== 'detail')
      }
      if (this.$route.name.includes('Related')) {
        actions = actions.filter((a) => a !== 'related')
      }
      if (this.$route.name.includes('Booking')) {
        actions = actions.filter((a) => a !== 'booking')
      }
      if (this.type === 'comment') {
        actions = actions.filter((a) => a !== (this.activeTab === 'true' ? 'browser' : 'unbrowser'))
      }
      if (this.data && this.data.status === 'public') {
        actions = actions.filter((a) => a !== 'public')
      }
      if (this.data && this.data.status === 'private') {
        actions = actions.filter((a) => a !== 'private')
      }

      const { endpoint, resource_type } = getResourceInfo(this.type)
      actions = actions.filter((a) => {
        const iamAction = ACTION_TO_IAM_MAP[a]
        if (!iamAction) return true
        return checkIamAction(endpoint, resource_type, iamAction)
      })

      return actions.map((a) =>
        TYPE.ALL_ACTIONS.find((action) => a === action.key)
      ).filter(Boolean)
    },

    placeType() {
      return TYPE.PLACES.find((p) => p.value === this.type)
    }
  },
  methods: {
    getToShowRouter,
    getIconStyle(type) {
      const colors = {
        primary: '#409EFF',
        success: '#67C23A',
        warning: '#E6A23C',
        danger: '#F56C6C',
        info: '#909399',
        default: '#606266'
      }
      return {
        color: colors[type] || '#606266',
        marginRight: '8px',
        width: '14px',
        textAlign: 'center'
      }
    },
    handleAction(key, row) {
      switch (key) {
        case 'showQR':
          this.$emit('showQR')
          break
        case 'copy':
          this.$clipboard(`${window.location.origin}/place/${row.id}?locale=${this.language}`)
          this.$notify.success({
            title: 'Thông báo !',
            message: 'Đã copy thành công !'
          })
          break
        case 'edit':
          if (this.routerData && this.routerData.name) {
            this.$router.push({ name: `${this.routerData.name}Info`, params: { id: row.id }})
          } else {
            this.$router.push(this.getToShowRouter(row))
          }
          break
        case 'detail':
          this.$router.push({ name: `${this.routerData.name}Detail`, params: { id: row.id }})
          break
        case 'related':
          this.$router.push({ name: `${this.routerData.name}Related`, params: { id: row.id }})
          break
        case 'booking':
          this.$router.push({ name: `${this.routerData.name}Booking`, params: { id: row.id }})
          break
        case 'browser':
          updateComment({ id: row.id, approved: true }).then(() => {
            this.$notify.success({
              title: 'Thông báo',
              message: 'Phê duyệt thành công.'
            })
            this.$emit('reloadPage')
          }).catch((error) => {
            this.$notify.error({
              title: 'Thông báo',
              message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
            })
          })
          break
        case 'unbrowser':
          updateComment({ id: row.id, approved: false }).then(() => {
            this.$notify.success({
              title: 'Thông báo',
              message: 'Bỏ phê duyệt thành công.'
            })
            this.$emit('reloadPage')
          }).catch((error) => {
            this.$notify.error({
              title: 'Thông báo',
              message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
            })
          })
          break
        case 'delete':
          this.$confirm('Bạn có chắc chắn muốn xóa không?', 'Xác nhận', {
            confirmButtonText: 'Xóa',
            cancelButtonText: 'Đóng',
            type: 'warning'
          }).then(() => {
            let request = null
            if (this.type === 'comment') {
              request = deleteComment({ ids: row.id })
            } else {
              request = deletePlace(row.id)
            }
            request.then(() => {
              this.$notify.success({
                title: 'Thông báo',
                message: 'Xóa thành công'
              })
              if (this.tableData.length === 1) {
                this.$emit('changePage', this.page > 1 ? this.page - 1 : this.page)
              }
              this.$emit('reloadPage')
              if (['country', 'area'].includes(this.type)) {
                this.$emit('reloadConstants')
              }
            }).catch((error) => {
              this.$notify.error({
                title: 'Thông báo',
                message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
              })
            })
          })
          break
        case 'public':
          enablePlace({ id: row.id, enabled: true }).then(() => {
            this.$notify.success({
              title: 'Thông báo',
              message: 'Public thành công.'
            })
            this.$emit('reloadPage')
          }).catch((error) => {
            this.$notify.error({
              title: 'Thông báo',
              message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
            })
          })
          break
        case 'private':
          enablePlace({ id: row.id, enabled: false }).then(() => {
            this.$notify.success({
              title: 'Thông báo',
              message: 'Private thành công.'
            })
            this.$emit('reloadPage')
          }).catch((error) => {
            this.$notify.error({
              title: 'Thông báo',
              message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
            })
          })
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
